import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { cancelScaleFloorPlanAction } from 'actions/floorPlanActions'
import { notificationAction } from 'actions/notificationActions'

const mapStateToProps = ({ map: { floorPlans }, ui: { scaling, floorPlanScaleID } }) => {
  const currentFloorplan = floorPlans.find(f => f.id === floorPlanScaleID)
  return { currentFloorplan, scaling }
}

class FloorPlanScaler extends React.Component {
  state = { unit: 'Feet' }

  complete() {
    const { state: { unit }, props: { currentFloorplan: { overlay, scaler }, notificationAction, cancelScaleFloorPlanAction } } = this
    let width = this.refs.width.value
    const distance = scaler.getDistance()

    if ((width === undefined) || (width.length === 0) || !width.trim()) {
      return notificationAction('Must enter distance to scale floorplan')
    }

    width = parseFloat(width)
    if (isNaN(width) || (width < 1)) {
      return notificationAction('Please enter a valid distance')
    }

    if (unit === 'Feet') width = width * 0.3048
    overlay.resizeByScale(width / distance)
    cancelScaleFloorPlanAction()
  }

  render() {
    const { currentFloorplan, scaling, cancelScaleFloorPlanAction, classes } = this.props

    if (!currentFloorplan || !scaling) return null

    return (
      <div className={classes.floorPlanScaler}>
        <div className={classes.header}>
          Scale Floor Plan
        </div>
        <span className={classes.info}>Adjust the distance bar and enter here:</span>
        <div className={classes.row}>
          <input
            type='tel'
            className={classes.widthInput}
            ref='width'
            placeholder='Distance...'
          />
          <label htmlFor='Feet' className={classes.label}>
            <input onClick={_ => this.setState({ unit: 'Feet' })} defaultChecked ref='feet' type='radio' name='UOM' value='Feet' className={classes.radio} />
            ft
          </label>
          <label htmlFor='Meters' className={classes.label}>
            <input onClick={_ => this.setState({ unit: 'Meter' })} ref='meter' type='radio' name='UOM' value='Meter' className={classes.radio} />
            m
          </label>
        </div>
        <div className={classes.row}>
          <div onClick={this.complete.bind(this)} className={classes.button}>
            Scale
          </div>
          <div onClick={_ => cancelScaleFloorPlanAction()} className={classes.cancelButton}>
            Cancel
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { cancelScaleFloorPlanAction, notificationAction })(injectSheet(style)(FloorPlanScaler))



// WEBPACK FOOTER //
// ./src/components/BottomBar/FloorPlanScaler/index.js